import Cookies from 'js-cookie';

export const NEXT_HINT_MESSAGE = 'NEXT_HINT_MESSAGE';
export const PREV_HINT_MESSAGE = 'PREV_HINT_MESSAGE';
export const SET_DISABLE_HINT_MESSAGES = 'SET_DISABLE_HINT_MESSAGES';

export const TWO_SEGMENTS_DIALOG_SHOWN = 'TWO_SEGMENTS_DIALOG_SHOWN';
export const SHOW_TWO_SEGMENTS_DIALOG = 'SHOW_TWO_SEGMENTS_DIALOG';

const setDisableCookieWithExpiry = (cname, cvalue) => {
  const expire = new Date();
  expire.setHours(24, 0, 0, 0);
  Cookies.set(cname, cvalue, { expires: expire });
};

export const jumpToNextHintMessage = () => (dispatch) => {
  dispatch({ type: NEXT_HINT_MESSAGE });
};

export const jumpToPrevHintMessage = () => (dispatch) => {
  dispatch({ type: PREV_HINT_MESSAGE });
};

export const setDisableHintMessages = () => (dispatch) => {
  setDisableCookieWithExpiry('disable_hint_messages', true);
  dispatch({ type: SET_DISABLE_HINT_MESSAGES });
};

export const twoSegmentsDialogShown = () => (dispatch) => {
  dispatch({ type: TWO_SEGMENTS_DIALOG_SHOWN });
};

export const showTwoSegmentsDialog = () => (dispatch) => {
  dispatch({ type: SHOW_TWO_SEGMENTS_DIALOG });
};
